<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="pull-right m-3">
                    <router-link class="btn btn-brand" :to="relationCreateUrl">{{ uLang('app.add_type', { type: lang('app.relation') }) }}</router-link>
                </div>

                <relations-table
                    :apiUrl="apiUrl"
                    :columns="columns"
                    :filterable="filterable"
                >
                    <template slot="city"></template>
                </relations-table>
            </div>
        </div>
    </div>
</template>
<script>
    import RelationsTable from '~/components/tables/admin/relation/table'

    export default {
        name: "RelationsTab",

        components: {
            RelationsTable,
        },

        props: {
            apiUrl: {
                type: String,
                required: true,
            },
            organisationId: {
                required: false,
            }
        },

        data() {
            return {
                columns: [
                    'name',
                    'email',
                    'phone_number',
                    'mobile',
                    'actions',
                ],
                filterable: null,
            }
        },

        computed: {
            relationCreateUrl() {
                if (this.organisationId) {
                    return {
                        name: 'admin.organisations.relations.create',
                        params: {
                            organisationId: this.organisationId,
                        },
                    };
                }

                return {
                    name: 'admin.relations.create',
                };
            },
        },
    }
</script>
<style scoped></style>